<!-- 销售订单合并 -->
<template>
	<div class='page_content'>
		<el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false"
			append-to-bodycustom-class="drawer_box" direction="ltr" size="100%">
			<salesOrderAction v-if="showStatus" ref="salesOrderAction" @drawerCancel="drawerCancel" @toDetail="toDetail"
				:actionData="actionData"></salesOrderAction>
		</el-drawer>
		<div class="page_content_top">
			<div class="page_content_top_line">
				<el-button type="primary" size="mini" @click="actionSet(buttonValue)"
					v-for="(buttonValue,buttonKey) in buttonList" :key="buttonKey">
					{{buttonValue.jurName}}
				</el-button>
				<el-button type="primary" icon="el-icon-refresh" size="mini" @click="getPageInfo()">
					刷新
				</el-button>
			</div>
			<div class="page_content_top_line">
				<el-form :inline="true" :model="getRequestData" class="demo-form-inline" v-if="pageShowData.jurHead"
					size="mini">
					<el-form-item :label="formOneValue.showField" v-if="formOneValue.isShow==1"
						v-for="(formOneValue,formOneKey) in pageShowData.jurHead.jurconfigform" :key="formOneKey">
						<!-- 业务员	 -->
						<el-select filterable v-if="formOneValue.entityField == 'woamSalesman'"
							v-model="getRequestData[formOneValue.entityField]">
							<el-option label="全部" value="">
							</el-option>
							<el-option v-for="(values,keys) in userOneList" :key="keys" :label="values.opmName"
								:value="values.opmId">
							</el-option>
						</el-select>
						<el-date-picker v-else-if="formOneValue.entityField == 'start'" size="mini"
							v-model="getRequestData[formOneValue.entityField]" format="yyyy 年 MM 月 dd 日"
							value-format="timestamp" type="date" placeholder="选择日期"></el-date-picker>
						<el-date-picker v-else-if="formOneValue.entityField == 'end'" @change="changeTime" size="mini"
							v-model="getRequestData[formOneValue.entityField]" format="yyyy 年 MM 月 dd 日"
							value-format="timestamp" type="date" placeholder="选择日期"></el-date-picker>

						<!-- 销往单位/客户	 -->
						<el-input v-else-if="formOneValue.entityField == 'cmId'" clearable
							v-model="getRequestData.cmName"
							@keyup.enter.native="openSearch(formOneValue.searchId, 0, 'cmId', 'cmName')">
							<el-button @click="openSearch(formOneValue.searchId, 0, 'cmId', 'cmName')" slot="append"
								icon="el-icon-search"></el-button>
						</el-input>
						<!-- 检索方案 -->
						<el-input v-else-if="formOneValue.fieldType == 'search'" clearable
							v-model="getRequestData[formOneValue.entityField]"
							@keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField,formOneValue.setField)">
							<el-button
								@click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField,formOneValue.setField)"
								slot="append" icon="el-icon-search"></el-button>
						</el-input>
                        <el-select clearable size="mini" v-else-if="formOneValue.fieldType == 'formatter'" v-model="getRequestData[formOneValue.entityField]" placeholder="请选择">
                            <el-option v-for="item in JSON.parse(formOneValue.formatterContent)"
                                :key="item.key" :label="item.value" :value="item.key">
                            </el-option>
                        </el-select>
						<el-input v-else v-model.trim="getRequestData[formOneValue.entityField]" size="mini"
							:maxlength="$store.state.inputLength"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" size="mini" @click="searchData">查询</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<div class="page_content_center">
			<el-table v-if="pageShowData.jurTableVo" stripe :data="returnData.list" height="100%" border
				style="width: 100%" highlight-current-row size="mini">
				<el-table-column label="选择操作" width="80">
					<template slot-scope="scope">
						<el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
							<i class="el-icon-thumb"></i>
						</el-radio>
					</template>
				</el-table-column>
				<el-table-column v-if="tableValye.isShow==1"
					v-for="(tableValye,tableKey) in pageShowData.jurTableVo.jurconfigtable" :key="tableKey"
					show-overflow-tooltip :min-width="tableValye.fieldWeight" :prop="tableValye.entityField"
					:label="tableValye.showField">
					<template slot-scope="scope">
						<span v-if="tableValye.fieldType == 'date'">
							<span v-if="scope.row[tableValye.entityField]">
								{{$common.getLocalTime(scope.row[tableValye.entityField])}}
							</span>
						</span>
						<el-tag size="mini" v-else-if="tableValye.entityField == 'isWms'">
							{{scope.row.isWms == 0 ? '否' : '是'}}
						</el-tag>
						<span v-else-if="tableValye.isRift == 1">
							<a
								@click="toDetail(scope.row[tableValye.riftField])">{{scope.row[tableValye.entityField]}}</a>
						</span>
						<el-tag size="mini" v-else-if="tableValye.entityField == 'woamState'">
							{{$common.getIsGsp(tableValye.formatterContent,scope.row.woamState)}}</el-tag>
						<span v-else>
							{{scope.row[tableValye.entityField]}}
						</span>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="page_content_bottom">
			<el-pagination background @size-change="setDataPageSize" @current-change="setDataPageNumber"
				:current-page="getRequestData.page" :page-sizes="[30,50,100,500]" :page-size="30"
				layout="total, sizes, prev, pager, next, jumper" :total="returnData.total">
			</el-pagination>
		</div>
		<el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
			<SearchScheme ref="searchScheme" :id="seId" :smId="cmId" :parentSearchData="parentSearchData"
				@TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
		</el-dialog>
		<printPlan ref="printPlan"></printPlan>
		<!-- 自定义设计 -->
		<customDesign ref="customDesign"></customDesign>
	</div>
</template>

<script>
	//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
	//例如：import 《组件名称》 from '《组件路径》';
	import SearchScheme from "../../../byComponents/SearchScheme.vue"
	import salesOrderAction from '@/components/salesOrderAction.vue'
	export default {
		//import引入的组件需要注入到对象中才能使用
		components: { SearchScheme,salesOrderAction },
		data() {
			//这里存放数据
			return {
				getRequestData: {
					woamSalesman: '',  // 业务员
					cmId: '',  // 客户ID
					cmName: '', // 客户名称
                    orderType: 0,  //	订单类型0.药品1.器械
					page: 1,
					rows: 30,
					start: '',	//开始上一个月
					end: '',	//当天最后时间
				},
				returnData: {
					pages: 0,  // 总页数
					total: 0,  // 总条数
					pageNum: 0,  // 当前页数
					list: []
				},
				buttonList: [],

				pageShowData: [],
				formDataList: [],
				selectedDataIndex: 0,

				userOneList: [],
				seTitle: "",//检索
				DialogVisible: false,
				seWidth: '0',
				seId: 0,
				cmId: 0,
				showStatus: false,
				actionData: {},
				parentSearchData: {},
				sField: ''
			};
		},
		//监听属性 类似于data概念
		computed: {},
		//监控data中的数据变化
		watch: {
			'getRequestData.cmName': {
				handler: function (newValue, oldValue) {
					if (newValue == '') {
						this.getRequestData.cmId = ''
					}
				},
				deep: true,
			}
		},
		//方法集合
		methods: {
			//结束时间改成最后时间
			changeTime(val) {
				if (val) {
					var time = val + 24 * 60 * 60 * 1000 - 1
					this.getRequestData.end = time
				}
			},
			// 子组件触发
			drawerCancel() {
				this.showStatus = false
				this.getDataList()
			},
			// 点击穿透字段 传参单号
			toDetail(orderId) {
				if (orderId) {
					// 设置为true 打开穿透组件首页    
					var isPenetrate = true
					// 设置缓存 存入点击单号
					this.resetSetItem('penetrateOrderId', orderId);
					// 与父级跨域通信 传递isPenetrate参数
					window.parent.postMessage({  //向窗口发送MessageEvent消息
						cmd: 'returnFormJson',
						params: { isPenetrate } //参数
					}, '*');
				}
			},
			// 赋值字段
			paramValue(val) {
				let arr = this.sField.split(',')
				arr.forEach(item => {
					this.getRequestData[item] = val[item]
				})
			},
			// 检索Id, 索引(表格中), 标识
			openSearch(sId, index, type, sField) {
				this.DialogVisible = true
				this.seId = sId
				this.sField = sField
				this.parentSearchData[type] = this.getRequestData[type]
			},
			//检索带回数据
			changeInputModel(val) {
				if (val != "" || val != undefined) {
					this.DialogVisible = false;
					if (val.cmId) {//销售单位
						this.cmId = val.cmId
						this.paramValue(val)
					}
				}
			},
			getSeWidth(e) {
				// console.log(e);
				this.seWidth = e + "%";
			},
			getWidth(e) {
				// console.log(e);
				this.exWidth = e + "%";
			},
			getSearchName(e) {
				// console.log(e);
				this.seTitle = e;
			},

			// 获取业务员
			async getSpecialUser() {
				let responseData = await this.$http.getSpecialUser({ opmSalesperson: 1 })
				if (responseData.status == 200) {
					this.userOneList = responseData.result
				} else {
					this.$message({
						message: responseData.message,
						type: 'error'
					});
				}
			},
			isShowData(name, value) {
				switch (name) {
					case 'customerList':
						var dataInfo = sessionStorage.getItem('selectCustomerData')
						if (dataInfo) {
							dataInfo = JSON.parse(dataInfo)
							this.getRequestData.cmId = dataInfo.cmId
							this.getRequestData.cmName = dataInfo.cmName
						}

						break;

					default:
						this.getRequestData[name] = value

				}
			},

			async getPageInfo() {
				var pathId = parent.getMenuInfo(this.$route.path)
				let responseData = await this.$http.getJur({ ids: [pathId.jurId] })
				if (responseData.status == 200) {
					this.getButtonList()
					this.pageShowData = responseData.result
					this.formDataList = this.pageShowData.jurFormVoList
					this.getDataList()
				} else {
					this.$message({
						message: responseData.message,
						type: 'error'
					});
				}
			},



			// 动作集合
			actionSet(actionData) {
				switch (actionData.actionType) {
					case 0:
						this.showStatus = true
						this.actionData = {
							cate: 0, formData: this.formDataList,
							oldData: '', orderId: '', printSouce: '',
							printJurId: '', type: 'merge'
						}
						break;
					case 1:
						if (this.returnData.list.length <= 0) {
							if (!dataInfo) {
								this.$message({
									message: '暂无数据',
									type: 'error'
								});
								return false
							}
						}
						var dataInfo = JSON.parse(JSON.stringify(this.returnData.list[this.selectedDataIndex]))
						if (!dataInfo) {
							this.$message({
								message: '请先选中要操作的数据',
								type: 'error'
							});
							return false
						}
						this.showStatus = true
						this.actionData = {
							cate: 1, formData: this.formDataList,
							oldData: dataInfo, orderId: dataInfo.woamId, printSouce: '',
							printJurId: '', type: 'merge'
						}
						break;
					case 2:
						this.delDataAction()
						break;
					case 3:
						this.submitData()
						break;
					case 8:
						this.showPrintPlan()
						break;
					case 15:
						this.openFormDesign()
						break;
				}
			},
			openFormDesign() {
				let pathInfo = parent.getMenuInfo(this.$route.path)
				this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
			},
			showPrintPlan() {
				var dataInfo = this.returnData.list[this.selectedDataIndex]
				if (!dataInfo) {
					this.$message({
						message: '请先选中要操作的数据',
						type: 'error'
					});
					return false
				}
				// 调用全局方法 判断Websocket是否连接
				if (this.$printSocketApi.printExeMsg() != false) {
					// 选中的数据
					var info = this.returnData.list[this.selectedDataIndex]
					this.$refs.printPlan.openDia(info.woamId)
				} else {
					return
				}
			},
			// 提交审核
			submitData() {
				if (this.returnData.list.length <= 0) {
					if (!dataInfo) {
						this.$message({
							message: '暂无数据',
							type: 'error'
						});
						return false
					}
				}
				if (!this.returnData.list[this.selectedDataIndex]) {
					this.$message({
						message: '请先选择您要操作的数据',
						type: 'error'
					});
					return false
				}
				var dataInfo = this.returnData.list[this.selectedDataIndex]
				this.$confirm('确定要提交审核吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					var delData = {
						ids: [dataInfo.woamId]
					}
					let responseData = await this.$http.submitSalesOrder(delData)
					if (responseData.status == 200) {
						this.$message({
							type: 'success',
							message: '操作成功!'
						});

						this.getDataList()
					} else {
						this.$message({
							message: responseData.message,
							type: 'error'
						});
					}

				}).catch(() => { });

			},
			// 数据搜索
			searchData() {
				this.getRequestData.page = 1
				this.getDataList()
			},
			// 数据翻页
			setDataPageNumber(val) {
				this.getRequestData.page = val
				this.getDataList()
			},

			// 切换显示条数
			setDataPageSize(val) {
				this.getRequestData.page = 1
				this.getRequestData.rows = val
				this.getDataList()
			},


			// 获取数据列表
			async getDataList() {

				let responseData = await this.$http.getSalesOrder(this.getRequestData)
				if (responseData && responseData.status == 200) {
					let resData = JSON.parse(JSON.stringify(responseData))
					this.returnData.list = resData.result.list
					this.returnData.pages = resData.result.pages
					this.returnData.total = resData.result.total
					this.returnData.pageNum = resData.result.pageNum
					this.selectedDataIndex = 0

				} else {
					this.$message({
						message: responseData.message,
						type: 'error'
					});
				}
			},


			// 删除数据
			delDataAction() {
				if (this.returnData.list.length <= 0) {
					if (!dataInfo) {
						this.$message({
							message: '暂无数据',
							type: 'error'
						});
						return false
					}
				}
				var dataInfo = this.returnData.list[this.selectedDataIndex]
				if (!dataInfo) {
					this.$message({
						message: '请先选中要操作的数据',
						type: 'error'
					});
					return false
				}
				this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					var delData = {
						ids: [dataInfo.woamId]
					}
					let responseData = await this.$http.delSalesOrder(delData)
					if (responseData.status == 200) {
						this.$message({
							type: 'success',
							message: '删除成功!'
						});

						this.getDataList()
					} else {
						this.$message({
							message: responseData.message,
							type: 'error'
						});
					}

				}).catch(() => { });

			},

			// 获取按钮权限
			async getButtonList() {
				this.buttonList = await this.$common.getActionButton()
				
			},
//获取状态
			getIsGsp(str, val) {
				try {
					str && str.replace(/\\/g, '')
					let arr = JSON.parse(str)
					let len = arr.length
					let newStr = ''
					for (let i = 0; i < len; i++) {
						if (arr[i].key === val) {
							newStr = arr[i].value
							break;
						}
					}
					return newStr
				} catch (ex) {
					return str
				}
			},

		},
		//生命周期 - 创建完成（可以访问当前this实例）
		created() {
			this.getRequestData.start = this.$common.getStartTime()
			this.getRequestData.end = this.$common.getEndTime()
			this.getPageInfo()
			this.getSpecialUser()

		},
		//生命周期 - 挂载完成（可以访问DOM元素）
		mounted() {

		},
		beforeCreate() { }, //生命周期 - 创建之前
		beforeMount() { }, //生命周期 - 挂载之前
		beforeUpdate() { }, //生命周期 - 更新之前
		updated() { }, //生命周期 - 更新之后
		beforeDestroy() { }, //生命周期 - 销毁之前
		destroyed() { }, //生命周期 - 销毁完成
		activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
	}
</script>
<style scoped>
	.table_content_tag {
		margin-right: 1rem;
	}

	.el-tabs--border-card_new {
		height: 85vh;
		overflow-y: scroll;
	}
</style>